<script setup lang="ts">

import {usePageStore} from "@/stores/pageStore";
import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from 'vue-router';
import {Page} from "@/models/Page";
import PageList from "@/components/Pages/PageList.vue";
import {useUserStore} from "@/stores/userStore";
import { useI18n } from 'vue-i18n';
import CustomButton from "@/components/Button/Button.vue";

const route = useRoute();
const router = useRouter();
const pageStore = usePageStore()
const userStore = useUserStore()
const loading = ref(false);
const page = ref<Page>({})
const { t } = useI18n();

const loadPage = () => {
  loading.value = true;
  pageStore.getPage(route.params.child)
      .then((data) => {
        page.value = data.data
      })
      .catch(() => {
        route.push({path: 'notfound'})
      }).finally(() => loading.value = false)


}
watch(route, () => {
  loadPage()
});
onMounted(() => {
  loadPage()
});

</script>
<template>
  <div class="flex flex-col" v-if="!loading">
    <div v-if="page.imageSet && page.imageSet['1600w']"
         :style="{ backgroundImage: 'url(' + page.imageSet['1600w'] + ')' }"
         class="main-image flex justify-end">
      <div class="container bg-image flex flex-col items-center">
        <div class="news-content flex flex-col w-3/4 gap-4 mb-8">
          <h1 class=" drop-shadow self-start responsive-title-2 text-white font-bold">
            {{ page.title }}
          </h1>
        </div>
      </div>

    </div>

    <div class="container mt-8 flex flex-col items-center">
      <div class="news-content flex flex-col w-3/4 gap-4">
        <div class="flex flex-col gap-2">
          <h3 class="text-bw-darkGrey  lg: responsive-body-small self-start">
            {{ userStore.formatDateWithCustomPatternMapping(page.publishedAt, 'MMM DD, YYYY') }}
          </h3>

        </div>
        <div class="responsive-body-large text-black mix-blend-multiply">

          <div v-html="page.rendered"/>
        </div>
      </div>

      <div class="w-full travel-inspirations">
        <div class="pt-4 pb-24">
          <CustomButton
              type="black"
              :outlined="false"
              :rounded="true"
              :icon="'/assets/icons/svg/Arrow_left_white_16x16.svg'"
              :hoverIcon="'/assets/icons/svg/Arrow_left_white_16x16.svg'"
              @click="router.go(-1)"
          >
            {{ t('goback') }}
          </CustomButton>
        </div>
        <PageList slug="travel-inspiration"/>
      </div>
    </div>
  </div>
  <div class="min-h-64" v-else>

  </div>
  

</template>

<style scoped>
.main-image {
  background-size: cover;
  background-position: center;
  max-height: 650px;
  height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}

@media (max-width: 1535px) {
  .bp-image-widget {
    height: 25vh;
  }
}

@media (max-width: 1280px) {
  .bp-image-widget {
    height: 18vh;
  }
}

@media (max-width: 1024px) {

  .news-content {
    width: 100%;
  }
}

:deep(.title-pagelist){
  font-size: 1.25rem!important;
}


</style>